import React, { useContext, useState } from 'react';
import { deleteUserDelete } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import { useForm } from 'react-hook-form';
import { deleteUserNotice, somethingWentWrongNotice } from '../UI/Notifications';
import { SearchContext } from '../../context/Search';
import DeleteUserModalContent from '../ModalContents/DeleteUserModalContent';
import Modal from '../UI/Modal';

const DeleteUser = ({ id }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const history = useHistory();
  const { setSearchTrigger, searchTrigger, setLoading } = useContext(SearchContext);
  const [show, setShow] = useState(false);
  const { handleSubmit } = useForm();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Delete User");
    }

    setLoading(false);
  }

  const onSubmit = () => {
    setLoading(true);
    deleteUserDelete({user_id: id})
      .then(() => {
        handleClose();
        setSearchTrigger(!searchTrigger);
        setLoading(false);
        deleteUserNotice();
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        handleClose();
      });
  }

  const deleteUser = () => {
    handleShow();
  }

  return (
    <>
      <div
        onClick={() => deleteUser()}
        className="Dropdown_Item"
      >
        <span className="ml-2">Delete User</span>
      </div>
      <Modal 
        handleClose={handleClose} 
        show={show}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        buttonLabel="Delete"
      >
        <DeleteUserModalContent />
      </Modal>
    </>
  )
}

export default DeleteUser;
